import { isProduction, isTesting } from "@web-monorepo/environment";
import { makeSafeStorageWrapper } from "./makeSafeStorageWrapper";
import { getBrowserStorage } from "./getBrowserStorage";

export const sessionStorage = makeSafeStorageWrapper(
  "session",
  getBrowserStorage("session"),
  isProduction || isTesting,
);
